module.exports = __webpack_public_path__ + "img/img9.28ccf9ef.svg";